"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfinityDocs = void 0;
var InfinityDocs = exports.InfinityDocs = {
  name: 'Infinity',
  category: 'Constants',
  syntax: ['Infinity'],
  description: 'Infinity, a number which is larger than the maximum number that can be handled by a floating point number.',
  examples: ['Infinity', '1 / 0'],
  seealso: []
};